// extracted by mini-css-extract-plugin
export default {"root":"suspense-fallback-module--root--fc73c","header":"suspense-fallback-module--header--02222","body":"suspense-fallback-module--body--bab5e"};